import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/shared/services/globals';

@Component({
  selector: 'app-medical-platform',
  templateUrl: './medical-platform.component.html',
  styleUrls: ['./medical-platform.component.css']
})
export class MedicalPlatformComponent implements OnInit {

  constructor(private router: Router,public global: Globals,translate: TranslateService) {
    translate.setDefaultLang('AR');
  }

  ngOnInit() {
  }

}
